import { authPost } from "../http_client.js";
import { PrimedResponses } from "../primed_responses.js";
import type { PlayerDto } from "../dto/player.dto.js";
import type { DailyTasksPayloadDto } from "../dto/daily_tasks.dto.js";
import type { DailyChallengePayloadDto } from "../dto/daily_challenge.dto.js";
import type { WinStreakTowerPayloadDto } from "../dto/win_streak_tower.dto.js";
import type { KeyHuntPayloadDto } from "../dto/key_hunt.dto.js";
import type { ConfigHashesResponse } from "./player.requests.js";

export interface BootstrapResponse
{
  player: PlayerDto;
  config_hashes: Record<string, string>;
  configs: Record<string, unknown>;
  daily_tasks: DailyTasksPayloadDto;
  daily_challenge: DailyChallengePayloadDto;
  win_streak_tower: WinStreakTowerPayloadDto;
  key_hunt?: KeyHuntPayloadDto;
  event_etags?: Partial<Record<"daily_tasks" | "daily_challenge" | "win_streak_tower" | "key_hunt", string>>;
  generated_at: string;
}

export function fetchBootstrap( known_hashes: Record<string, string>, types: string[] ): Promise<BootstrapResponse>
{
  return authPost<BootstrapResponse>( 'api/player/me/bootstrap', { config_hashes: known_hashes, types } );
}

export function primeFromBootstrap( payload: BootstrapResponse ): number
{
  let primed = 0;
  const hashes = payload.config_hashes ?? {};

  const hashes_response: ConfigHashesResponse = { hashes, generated_at: payload.generated_at };
  PrimedResponses.set( 'config_hashes', hashes_response );
  primed++;

  for ( const [ type, data ] of Object.entries( payload.configs ?? {} ) )
  {
    PrimedResponses.set( `content_config:${type}`, { data, hash: hashes[type] ?? null } );
    primed++;
  }

  const etags = payload.event_etags ?? {};
  if ( payload.daily_tasks ) { PrimedResponses.set( 'daily_tasks', payload.daily_tasks ); PrimedResponses.set( 'daily_tasks_etag', etags.daily_tasks ?? null ); primed++; }
  if ( payload.daily_challenge ) { PrimedResponses.set( 'daily_challenge', payload.daily_challenge ); PrimedResponses.set( 'daily_challenge_etag', etags.daily_challenge ?? null ); primed++; }
  if ( payload.win_streak_tower ) { PrimedResponses.set( 'win_streak_tower', payload.win_streak_tower ); PrimedResponses.set( 'win_streak_tower_etag', etags.win_streak_tower ?? null ); primed++; }
  if ( payload.key_hunt ) { PrimedResponses.set( 'key_hunt', payload.key_hunt ); PrimedResponses.set( 'key_hunt_etag', etags.key_hunt ?? null ); primed++; }

  return primed;
}
